import { createSlice } from '@reduxjs/toolkit';
import { TripSlice, TripState } from '../types/trip';
import { getTrip, getTrips } from '../services/trip.service';

const TRIPS_INITIAL_STATE: TripSlice = {
  all: [],
  overallTrip: null,
  tripState: TripState.INITIAL,
  tripProgress: 0,
  tripSpeed: 16,
  loading: false,
  ENABLED_EVENT_CONTROLS: [],
};

const initialState = TRIPS_INITIAL_STATE;

export const tripSlice = createSlice({
  name: 'trip',
  initialState,
  reducers: {
    updateEventControls: (state, action) => {
      state.ENABLED_EVENT_CONTROLS = action.payload;
    },
    updateTripProgress: (state, action) => {
      state.tripProgress = action.payload;
    },
    startTrip: (state) => {
      state.tripState = TripState.PLAYING;
    },
    pauseTrip: (state) => {
      state.tripState = TripState.PAUSED;
    },
    selectTrip: (state) => {
      state.tripState = TripState.INITIAL;
      state.tripProgress = 0;
    },
    updateTripSpeed: (state, action) => {
      state.tripSpeed = action.payload;
    },
    resetTripState: (state) => {
      state.tripState = TripState.INITIAL;
      state.tripProgress = 0;
      state.tripSpeed = 16;
      state.all = [];
      state.loading = false;
      state.overallTrip = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTrips.fulfilled, (state, action) => {
      state.overallTrip = action.payload.overallTrip;
      state.all = action.payload.all;
      state.tripState = TripState.INITIAL;
      state.tripProgress = 0;
      state.loading = false;
    });

    builder.addCase(getTrips.pending, (state) => {
      state.tripState = TripState.INITIAL;
      state.tripProgress = 0;
      state.all = [];
      state.overallTrip = null;
      state.loading = true;
    });

    builder.addCase(getTrips.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getTrip.fulfilled, (state, action) => {
      const tripIndex = state.all.findIndex(
        (trip) => trip.id === action.payload.id,
      );
      if (tripIndex !== -1) {
        state.all[tripIndex] = action.payload;
      } else {
        state.all.push(action.payload);
      }
    });
  },
});

export const {
  updateTripProgress,
  startTrip,
  pauseTrip,
  selectTrip,
  updateTripSpeed,
  updateEventControls,
  resetTripState,
} = tripSlice.actions;
